import { ROLES, UserRoles } from '@bb/users';
import { AuthContext } from 'contexts';
import React from 'react';

const useIsBranchAdmin = () => {
  const { auth } = React.useContext(AuthContext);
  const isBranchAdmin = auth?.role === 'BRANCH_ADMIN';

  const authorizedLocations = isBranchAdmin
    ? [auth?.location, ...(auth?.locations || [])]
    : null;

  // Branch admins can only add/remove users from locations they are authorized for and ONLY if their role is not > BA.
  const branchAdminCanEdit = (user: {
    firstName: string;
    location: string;
    role?: UserRoles;
  }) => {
    if (ROLES[user.role] > ROLES.BRANCH_ADMIN) return false;
    return authorizedLocations.includes(user.location);
  };

  return { branchAdminCanEdit, isBranchAdmin, authorizedLocations };
};

export default useIsBranchAdmin;
